<div
  class="card"
  [ngStyle]="{
    'background-image':
      'url(' + (travel | travelImagePipe | imagePipe : 'travel' : 'lg') + ')'
  }"
  (click)="goTo()"
>
  <!-- <div class="content">
    <div class="front">
      <div class="label-postit">
        {{
          travel.name.length > 24
            ? (travel.name | slice : 0 : 24) + "..."
            : travel.name
        }}
      </div>
    </div>
    <div
      class="back"
      [ngStyle]="{
        'background-image':
          'linear-gradient(rgba(34,43,48,0.6), rgba(34,43,48,0.6)), url(' +
          (travel | travelImagePipe | imagePipe : 'travel' : 'lg') +
          ')'
      }"
    >
      <div class="back-content">
        <h3>{{ travel.name }}</h3>
        <div class="flex flex-column gap-1 md:gap-3 align-items-start">
          <p>
            <i class="pi pi-map-marker"></i>
            @for (c of travel.countries; track $index) {
            {{ c.country.name }}
            }
          </p>

          <p>
            <i class="pi pi-calendar"></i>
            {{ travel.from_date | date : "dd MMMM yyyy" }}
          </p>

          <p>
            <i class="pi pi-clock"></i>
            {{ dates | daysAndNights }}
          </p>

          <p class="price">
            <small>Da </small>
            {{
              travel.pricing_mode === 1
                ? (travel.price_room
                  | currency : travel.currency : "symbol" : ".0-0")
                : (cheapestPackagePrice
                  | currency : travel.currency : "symbol" : ".0-0")
            }}
          </p>
          <div
            class="mt-1 md:mt-6 flex align-items-center justify-content-center"
          >
            <p-button
              label="Scopri di più"
              styleClass="slide px-8"
              (click)="goTo()"
            ></p-button>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <div class="content">
    <div
      class="back"
      [ngStyle]="{
        'background-image':
          'linear-gradient(rgba(34,43,48,0.6), rgba(34,43,48,0.6)), url(' +
          (travel | travelImagePipe | imagePipe : 'travel' : 'lg') +
          ')'
      }"
    >
      <div class="back-content">
        <!-- <h3>{{ travel.name }}</h3> -->
        <div class="flex flex-column gap-1 md:gap-3 align-items-start">
          <div class="label-postit mb-3">
            {{
              travel.name.length > 24
                ? (travel.name | slice : 0 : 24) + "..."
                : travel.name
            }}
          </div>
          <p>
            <i class="pi pi-map-marker"></i>
            @for (c of travel.countries; track $index) {
            {{ c.country.name }}
            }
          </p>

          <p>
            <i class="pi pi-calendar"></i>
            {{ travel.from_date | date : "dd MMMM yyyy" }}
          </p>

          <p>
            <i class="pi pi-clock"></i>
            {{ dates | daysAndNights }}
          </p>

          <div class="flex align-items-center justify-content-end w-full">
            <p class="price">
              <small>Da </small>
              {{
                travel.pricing_mode === 1
                  ? (travel.price_room
                    | currency : travel.currency : "symbol" : ".0-0")
                  : (cheapestPackagePrice
                    | currency : travel.currency : "symbol" : ".0-0")
              }}
            </p>
          </div>
          <!-- <div
            class="mt-1 md:mt-6 flex align-items-center justify-content-center"
          >
            <p-button
              label="Scopri di più"
              styleClass="slide px-8"
              (click)="goTo()"
            ></p-button>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</div>
